import React from "react";

const AlertMessage = (props) => {
  return (
    <div className="alertMessage" {...props.estilosContenedor}>
      <div className="alertMessage__icono" {...props.estilosIcono}>
        {props.icono}
      </div>
      <p className="alertMessage__mensaje" {...props.estilosMensaje}>
        {props.mensaje}
      </p>
    </div>
  );
};

export default AlertMessage;
